import React from "react";

import { useIntl } from "react-intl";

import * as Sticker from "ds/Sticker";

import * as S from "./ResourcesSticker.style";

const ResourcesSticker = ({
  environmentTitle,
  url
}: {
  environmentTitle: string;
  url: string;
}) => {
  const intl = useIntl();

  return (
    <S.ResourcesStickerRoot priority="normal">
      <Sticker.Icon priority="normal" />
      <Sticker.Text>
        <S.StickerContent>
          {intl.formatMessage<React.ReactNode>(
            {
              id: "overview.no.configured.resources"
            },
            {
              link: chunks => (
                <S.Button variant="primary" to={url}>
                  {chunks}
                </S.Button>
              ),
              environment: environmentTitle
            }
          )}
        </S.StickerContent>
      </Sticker.Text>
    </S.ResourcesStickerRoot>
  );
};

export default ResourcesSticker;
